import { Component, inject } from '@angular/core';
import { SearchConfig } from '../../../model/api.model';
import { DataTableSchema } from '../../../model/dynamic-data-table.model';
import { Props, DynamicFormArray } from '../../../model/form.model';
import { JobRoleDynamicOptionSchema, JobTenureFilterSchema, JobTenureHistory, JobTenureHistorySearchConfig, JobTenureProps, JobTenureSearchConfig, JobTenureTableSchema, JobTenureTitle } from '../../../model/tenure/jobs-tenure.model';
import { TenureBaseComponent } from '../tenure-base/tenure-base.component';
import { PageContainerComponent } from '../../../layout/page-container/page-container.component';
import { OptionsFetchConfig } from '../../../model/common.model';
import { MatDialog } from '@angular/material/dialog';
import { TenureHistoryComponent } from "../tenure-history/tenure-history.component";
import { PaginatorService } from '../../../services/paginator-service.service';

@Component({
  selector: 'app-jobs-tenure',
  standalone: true,
  imports: [PageContainerComponent],
  providers: [PaginatorService],
  templateUrl: './jobs-tenure.component.html',
  styleUrl: './jobs-tenure.component.scss'
})
export class JobsTenureComponent extends TenureBaseComponent {
  protected override data: string = JobTenureTitle;
  protected override props: Props = JobTenureProps;
  protected override filterSchema: DynamicFormArray = structuredClone(JobTenureFilterSchema);
  protected override dataTableSchema: DataTableSchema = structuredClone(JobTenureTableSchema);
  protected override searchConfig: SearchConfig = structuredClone(JobTenureSearchConfig);
  protected JobDynamicOptionFields: OptionsFetchConfig = structuredClone(JobRoleDynamicOptionSchema);
      private userInfo = null;
      private readonly dialog = inject(MatDialog);
    override runCommonLogic(): void {
      this.updateLayoutButtonCallbacks();
      this.updateOptions();
      this.userInfo = JSON.parse(sessionStorage.getItem('UserInfo') ?? '');
      this.updateTableSchema();
    }
    updateTableSchema() {
      this.dataTableSchema.columnSchema.forEach(columnElm => {
        if (columnElm?.fieldType === 'Actions') {
          const actions = columnElm?.actionConfig;
          if (Array.isArray(actions) && actions.length > 0) {
            actions.forEach(action => {
              if (action.fieldKey === JobTenureHistory) {
                action.onClick = this.showHistoryOnClick
              } 
            })
          }
        }
      })
    }
     showHistoryOnClick = (event: any) => {
        if (!this.userInfo) {
          this.commonUtils.showMatSnackBar("User-info data missing, Please try again after sometime");
          return
        }
        event.tenureConfig=JobTenureHistorySearchConfig;
        const dialogRef = this.dialog.open(TenureHistoryComponent, {
          panelClass: 'tenure-history-dialog',
          data:event
        });
        const instance = dialogRef.componentInstance;
        instance.btnClose.subscribe(()=>{
          dialogRef.close()
        })
        instance.type = 'history';
      }
}
